import { creditNoteEndPoints } from "../constants/endpoints";
import { api } from "./api";
import { getApiOrganizationId } from "../utils/orgIdUtils";

export const downloadCreditNote = async (id: string) => {
  try {
    const response = await api.get(`${creditNoteEndPoints.download}/${id}`, {
      headers: {
        orgId: getApiOrganizationId(),
      },
    });
    return response.data.data;
  } catch (error) {
    throw new Error("Failed to download credit note");
  }
};

export const previewCreditNote = async (
  customerId: string,
  body: Record<string, any>
) => {
  try {
    const response = await api.post(
      `${creditNoteEndPoints.preview}/${customerId}`,
      body,
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Preview Credit Note Error:", error);
    if (error?.response) {
      throw error;
    }
    throw new Error("Failed to preview credit note");
  }
};

export const editCreditNote = async (
  customerId: string,
  data: Record<string, any>
) => {
  try {
    const response = await api.put(
      `${creditNoteEndPoints.edit}/${customerId}`,
      data,
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Edit Credit Note Error:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to edit credit note"
    );
  }
};

export const getAllCreditNotes = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  startDate?: string | null;
  endDate?: string | null;
  sortOrder?: "ASC" | "DESC";
  download?: boolean;
}) => {
  try {
    const query = new URLSearchParams();

    if (params.page) query.append("page", params.page.toString());
    if (params.limit) query.append("limit", params.limit.toString());
    if (params.search) query.append("search", params.search);
    if (params.startDate) query.append("startDate", params.startDate);
    if (params.endDate) query.append("endDate", params.endDate);
    if (params.sortOrder) query.append("sortOrder", params.sortOrder);
    if (params.download) query.append("download", String(params.download));

    const response = await api.get(
      `${creditNoteEndPoints.getAllCreditNotes}?${query.toString()}`,
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch all credit notes");
  }
};

export const deleteCreditNote = async (creditNoteNo: string) => {
  try {
    const response = await api.delete(
      `${creditNoteEndPoints.delete}/${creditNoteNo}`,
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Delete Credit Note Error:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to delete credit note"
    );
  }
};
export const saveCreditNote = async (
  customerId: string,
  data: Record<string, any>
) => {
  try {
    const response = await api.put(
      `${creditNoteEndPoints.save}/${customerId}`,
      data,
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Confirm Credit Note Error:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to confirm credit note"
    );
  }
};

export const getInvoiceFromOrders = async (
  customerId: string,
  orderIds?: string[]
) => {
  try {
    const params = new URLSearchParams();
    if (orderIds && orderIds.length > 0) {
      orderIds.forEach((id) => params.append("orderIds", id));
    }
    const query = params.toString();
    const response = await api.get(
      `${creditNoteEndPoints.getInvoiceFromOrders}/${customerId}${query ? `?${query}` : ""}`,
      {
        headers: {
          orgId: getApiOrganizationId(),
        },
      }
    );
    return response.data;
  } catch (error: any) {
    console.error("Get Invoice From Orders Error:", error);
    throw new Error(
      error?.response?.data?.message || "Failed to fetch invoice from orders"
    );
  }
};
